import dynamic from 'next/dynamic'
import {ErrorBoundary} from 'react-error-boundary'

import LogRocket from 'lib/logrocket'
import useApiStatusToast from 'lib/hooks/use-api-status-toast'
import useErrorHandlingToast from 'lib/hooks/use-error-handling-toast'

// Imported lazily because this will only be rendered on error.
const ErrorModal = dynamic(() => import('lib/components/error-modal'), {
  ssr: false
})

function onError(error: Error, info: {componentStack: string}) {
  LogRocket.captureException(error, {extra: info})
}

export function ErrorToaster() {
  useErrorHandlingToast()
  return null
}

export function ApiStatusToaster() {
  useApiStatusToast()
  return null
}

export default function ErrorHandler({children}: {children: React.ReactNode}) {
  return (
    <ErrorBoundary FallbackComponent={ErrorModal} onError={onError}>
      {children}
    </ErrorBoundary>
  )
}
